module.exports = __webpack_public_path__ + "static/rewards-card-lancer-swarm-48a584c4bcfc109db86e967b24f21fd4.png";